import React from 'react'
import { useSelector } from 'APP/Hooks/redux'
import IntakeHelpCentreButton from '../Intake/IntakeHelpCentreButton'
import { selectFeatures } from 'APP/Sagas/FeaturesSaga'

interface Props {
  screenName: string
}

const RegistrationIntakeHelpCentre: React.FC<Props> = ({ screenName }) => {
  const { enableRegistrationHelpCentre } = useSelector(selectFeatures)

  return enableRegistrationHelpCentre ? (
    <IntakeHelpCentreButton screenName={screenName} isRegistrationPage={true} />
  ) : null
}

export default RegistrationIntakeHelpCentre
